import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'bl-editor-toolbar-button',
  standalone: true,
  imports: [CommonModule, IonicModule, SvgIconComponent],
  template: `
    <ion-button
      (click)="$onClick.emit()"
      [attr.aria-label]="ariaLabel"
      [title]="title"
      [class.active]="isActive"
    >
      <svg-icon
        [key]="icon"
        size="lg"
      ></svg-icon>
    </ion-button>
  `,
  styles: [
    `
      ion-button {
        --color: var(--ion-color-medium);

        &:not(:active):hover {
          --color: var(--ion-color-primary);
          --background: rgba(var(--ion-color-primary-rgb), 0.1);
        }

        &.active {
          --background: rgba(var(--ion-color-primary-rgb), 0.1);
          --color: var(--ion-color-primary);
        }
      }
    `
  ]
})
export class EditorToolbarButtonComponent {
  @Input() ariaLabel = '';
  @Input() title = '';
  @Input() icon = '';
  @Input() isActive = false;
  @Output() $onClick = new EventEmitter<void>();
}
